import { render, staticRenderFns } from "./DebitorContact.vue?vue&type=template&id=70c996b8&"
import script from "./DebitorContact.vue?vue&type=script&lang=js&"
export * from "./DebitorContact.vue?vue&type=script&lang=js&"
import style0 from "./DebitorContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports